/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import createReducer from 'redux-functional-reducer'

import * as constants from 'constants/Header'

const initialState = {
  selectedPage: 0,
  notification: undefined,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SELECT_PAGE:
      return {
        ...state,
        selectedPage: action.page,
      }

    case constants.SET_NOTIFICATION:
      return {
        ...state,
        notification: {
          i18nText: action.i18nText,
          text: action.text,
          id: action.id,
          type: action.notifType
        },
      }
      
    case constants.CANCEL_NOTIFICATION:
      return {
        ...state,
        notification: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Header.js